import React, {useEffect, useState} from "react";
import ReactApexChart from "react-apexcharts";

// Helper functions outside component to avoid dependency issues
const safeToNumber = (value) => {
    const num = parseFloat(value);
    return !isNaN(num) && isFinite(num) ? num : 0;
};

const safeFormat = (val, decimals = 1) => {
    const num = safeToNumber(val);
    return num.toFixed(decimals);
};

export const RadialChart = ({perceptions}) => {
    console.log('perceptions - radial')
    console.log(Object.values(perceptions))

    // Process perceptions data safely
    const processedData = Object.entries(perceptions)
        .filter(([, value]) => {
            const num = parseFloat(value);
            return !isNaN(num) && isFinite(num);
        })
        .map(([key, value]) => ({
            key,
            value: safeToNumber(value) * 100
        }));

    const [state, setState] = useState({
        series: processedData.map(item => item.value),
        options: {
            track: {
                background: '#2f3237',
                show: true,
            },
            chart: {
                height: 100,
                type: 'radialBar',
            },
            plotOptions: {
                radialBar: {
                    hollow: {
                        size: "40%"
                    },
                    track: {
                        show: true,
                        background: '#222830',
                        strokeWidth: '80%',
                        opacity: '40%'
                    },
                    dataLabels: {
                        name: {
                            fontSize: 'clamp(0.8rem, 2.5vw, 1.2rem)',
                            offsetY: -5,
                        },
                        value: {
                            fontSize: 'clamp(1.4rem, 3.5vw, 1.7rem)', // Increased mobile size
                            color: '#ffffff',
                            offsetY: 5, // Position number below the Total text
                            formatter: function(val) {
                                return safeFormat(val);
                            }
                        },
                        total: {
                            show: true,
                            label: 'Total',
                            color: '#c2c2c2',
                            fontSize: 'clamp(0.8rem, 1.2vw, 0.7rem)', // Increased mobile size
                            offsetY: -15, // Position Total text above the number
                            formatter: function (w) {
                                const series = w.config.series || [];
                                if (series.length === 0) return '0.0';
                                const validSeries = series.filter(val => !isNaN(parseFloat(val)));
                                if (validSeries.length === 0) return '0.0';
                                const average = validSeries.reduce((a, b) => safeToNumber(a) + safeToNumber(b), 0) / validSeries.length;
                                return safeFormat(average);
                            }
                        }
                    }
                }
            },
            stroke: {
                lineCap: "round",
            },
            tooltip: {
                y: {
                    formatter: function(value) {
                        return safeFormat(value);
                    }
                }
            },
            labels: processedData.map(item => item.key),
        },
    });

    useEffect(() => {
        // Process perceptions data safely in useEffect
        const updatedProcessedData = Object.entries(perceptions)
            .filter(([, value]) => {
                const num = parseFloat(value);
                return !isNaN(num) && isFinite(num);
            })
            .map(([key, value]) => ({
                key,
                value: safeToNumber(value) * 100
            }));

        setState({
            series: updatedProcessedData.map(item => item.value),
            options: {
                track: {
                    background: '#2f3237',
                    show: true,
                },
                chart: {
                    height: 100,
                    type: 'radialBar',
                },
                plotOptions: {
                    radialBar: {
                        hollow: {
                            size: "40%"
                        },
                        track: {
                            show: true,
                            background: '#222830',
                            strokeWidth: '80%',
                            opacity: '40%'
                        },
                        dataLabels: {
                            name: {
                                fontSize: 'clamp(0.8rem, 2.5vw, 1.2rem)',
                                offsetY: -5,
                            },
                            value: {
                                fontSize: 'clamp(1.4rem, 3.5vw, 1.7rem)', // Increased mobile size
                                color: '#ffffff',
                                offsetY: 5, // Position number below the Total text
                                formatter: function(val) {
                                    return safeFormat(val);
                                }
                            },
                            total: {
                                show: true,
                                label: 'Total',
                                color: '#c2c2c2',
                                fontSize: 'clamp(0.8rem, 1.2vw, 0.7rem)', // Increased mobile size
                                offsetY: -15, // Position Total text above the number
                                formatter: function (w) {
                                    const series = w.config.series || [];
                                    if (series.length === 0) return '0.0';
                                    const validSeries = series.filter(val => !isNaN(parseFloat(val)));
                                    if (validSeries.length === 0) return '0.0';
                                    const average = validSeries.reduce((a, b) => safeToNumber(a) + safeToNumber(b), 0) / validSeries.length;
                                    return safeFormat(average);
                                }
                            }
                        }
                    }
                },
                stroke: {
                    lineCap: "round",
                },
                tooltip: {
                    y: {
                        formatter: function(value) {
                            return safeFormat(value);
                        }
                    }
                },
                labels: updatedProcessedData.map(item => item.key),
            },
        });
    }, [perceptions])

    return (
        <div id="chart">
            <ReactApexChart options={state.options} series={state.series} type="radialBar" height={350}/>
        </div>
    )
}